import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import style from './PaymentResult.module.scss';

const PaymentSuccess = () => {
	const navigate = useNavigate();
	const [animated, setAnimated] = useState(false);

	useEffect(() => {
		let isMounted = true;

		const timer = setTimeout(() => {
			if (isMounted) setAnimated(true);
		}, 150);

		return () => {
			isMounted = false;
			clearTimeout(timer);
		};
	}, []);

	useEffect(() => {
		const delayRedirect = setTimeout(() => {
			navigate('/');
		}, 5000);

		return () => {
			clearTimeout(delayRedirect);
		};
	}, [navigate]);

	return (
		<main className={style.success}>
			<div className={style['success__container']} role='status' aria-live='polite'>
				<div className={style['success__icon']}>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						viewBox='0 0 24 24'
						fill='none'
						strokeWidth='2'
						stroke='currentColor'
						width='100'
						height='100'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							d='M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
							style={{
								strokeDasharray: '50',
								strokeDashoffset: animated ? '0' : '50',
								transition: 'stroke-dashoffset 1s ease-in-out',
							}}
						/>
					</svg>
				</div>

				<div className={style['success__content']}>
					<h1 className={style['success__title']}>Оплата прошла успешно!</h1>
					<p className={style['success__message']}>
						Ваш платёж был успешно обработан. Спасибо за использование наших услуг!
					</p>
					<span className={style['success__hint']}>Через несколько секунд вы вернётесь на главную страницу.</span>
					<a href='/' className={style['success__button']}>
						Вернуться на главную
					</a>
				</div>
			</div>
		</main>
	);
};

export default PaymentSuccess;
